var _excluded = ["content", "aside", "asideWidthSpace", "gutterSizeSpace", "hasVisibleAsideOnlyOnLargeUp", "asideCollapseBreakpoint", "isReversed", "isCentered"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
export var defaultProps = {
  asideWidthSpace: 42,
  gutterSizeSpace: 20,
  asideCollapseBreakpoint: "large",
  isReversed: false,
  isCentered: false
};
var Container = styled.div.withConfig({
  componentId: "sc-1pz6ap5-0"
})(function (_ref) {
  var $breakpointValue = _ref.$breakpointValue,
    $isCentered = _ref.$isCentered,
    $isReversed = _ref.$isReversed;
  return css(["display:flex;flex-direction:column;", "{flex-direction:", ";align-items:", ";}"], breakpoint($breakpointValue), $isReversed ? "row-reverse" : "row", $isCentered ? "center" : undefined);
});
var Content = styled.div.withConfig({
  componentId: "sc-1pz6ap5-1"
})(function (_ref2) {
  var $breakpointValue = _ref2.$breakpointValue;
  return css(["flex:1;margin-bottom:", ";", "{margin-bottom:0;}"], space(2.5), breakpoint($breakpointValue));
});
var Aside = styled.div.withConfig({
  componentId: "sc-1pz6ap5-2"
})(function (_ref3) {
  var $widthSpace = _ref3.$widthSpace,
    $gutterSizeSpace = _ref3.$gutterSizeSpace,
    $hasVisibleAsideOnlyOnLargeUp = _ref3.$hasVisibleAsideOnlyOnLargeUp,
    $breakpointValue = _ref3.$breakpointValue,
    $switchMarginSide = _ref3.$switchMarginSide;
  return css(["display:", ";", "{display:block;width:", ";", "}"], $hasVisibleAsideOnlyOnLargeUp ? "none" : "block", breakpoint($breakpointValue), space($widthSpace), $switchMarginSide ? "margin-right: ".concat(space($gutterSizeSpace)) : "margin-left: ".concat(space($gutterSizeSpace)));
});
function ContentWithAsideOrg(_ref4) {
  var content = _ref4.content,
    aside = _ref4.aside,
    _ref4$asideWidthSpace = _ref4.asideWidthSpace,
    asideWidthSpace = _ref4$asideWidthSpace === void 0 ? defaultProps.asideWidthSpace : _ref4$asideWidthSpace,
    _ref4$gutterSizeSpace = _ref4.gutterSizeSpace,
    gutterSizeSpace = _ref4$gutterSizeSpace === void 0 ? defaultProps.gutterSizeSpace : _ref4$gutterSizeSpace,
    hasVisibleAsideOnlyOnLargeUp = _ref4.hasVisibleAsideOnlyOnLargeUp,
    _ref4$asideCollapseBr = _ref4.asideCollapseBreakpoint,
    asideCollapseBreakpoint = _ref4$asideCollapseBr === void 0 ? defaultProps.asideCollapseBreakpoint : _ref4$asideCollapseBr,
    _ref4$isReversed = _ref4.isReversed,
    isReversed = _ref4$isReversed === void 0 ? defaultProps.isReversed : _ref4$isReversed,
    _ref4$isCentered = _ref4.isCentered,
    isCentered = _ref4$isCentered === void 0 ? defaultProps.isCentered : _ref4$isCentered,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(Container, _extends({
    $breakpointValue: asideCollapseBreakpoint,
    $isReversed: isReversed,
    $isCentered: isCentered
  }, restProps), /*#__PURE__*/React.createElement(Content, {
    $breakpointValue: asideCollapseBreakpoint
  }, content), /*#__PURE__*/React.createElement(Aside, {
    $widthSpace: asideWidthSpace,
    $gutterSizeSpace: gutterSizeSpace,
    $hasVisibleAsideOnlyOnLargeUp: hasVisibleAsideOnlyOnLargeUp,
    $breakpointValue: asideCollapseBreakpoint,
    $switchMarginSide: isReversed
  }, aside));
}
export default ContentWithAsideOrg;